__turbopack_context__.v({
  "charCount": "FormEditor-module-scss-module__Pe0kEa__charCount",
  "charCountError": "FormEditor-module-scss-module__Pe0kEa__charCountError",
  "charCounterRow": "FormEditor-module-scss-module__Pe0kEa__charCounterRow",
  "error": "FormEditor-module-scss-module__Pe0kEa__error",
  "errorMsg": "FormEditor-module-scss-module__Pe0kEa__errorMsg",
  "field": "FormEditor-module-scss-module__Pe0kEa__field",
  "fieldDescription": "FormEditor-module-scss-module__Pe0kEa__fieldDescription",
  "input": "FormEditor-module-scss-module__Pe0kEa__input",
  "inputContent": "FormEditor-module-scss-module__Pe0kEa__inputContent",
  "inputElement": "FormEditor-module-scss-module__Pe0kEa__inputElement",
  "label": "FormEditor-module-scss-module__Pe0kEa__label",
  "labelWrapper": "FormEditor-module-scss-module__Pe0kEa__labelWrapper",
  "required": "FormEditor-module-scss-module__Pe0kEa__required",
});
